import { useState, useRef, useEffect } from "react";

export default function ProvinceSelect({
  provinces,
  value,
  onChange,
}: {
  provinces: any;
  value: any;
  onChange: any;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState("");
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (value) {
      setSelected(value);
    }
  }, [value]);

  const filtered = provinces.filter((p: any) =>
    p.PROVINCE_NAME.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (province: any) => {
    setSelected(province.PROVINCE_NAME);
    onChange(province.PROVINCE_NAME);
    setIsOpen(false);
    setSearch(""); // clear search on select
  };

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e: any) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full" ref={containerRef}>
      <label className="block mb-1 font-medium text-sm">จังหวัด</label>
      <div
        className="border border-gray-500 rounded-lg font-noto px-3 py-2 cursor-pointer bg-white"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {selected || "เลือกจังหวัด"}
      </div>

      {isOpen && (
        <div className="absolute z-10 mt-2 w-full bg-white border border-gray-500 rounded-xl shadow-lg">
          <input
            type="text"
            className="w-full px-3 py-2 border-b border-gray-200 outline-none"
            placeholder="พิมพ์เพื่อค้นหา"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          <ul className="max-h-60 overflow-y-auto">
            {filtered.length === 0 ? (
              <li className="p-2 text-gray-500">ไม่พบจังหวัด</li>
            ) : (
              filtered.map((province: any) => (
                <li
                  key={province.PROVINCE_NAME}
                  className="px-4 py-2 hover:bg-green-100 cursor-pointer"
                  onClick={() => handleSelect(province)}
                >
                  {province.PROVINCE_NAME}
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
